import { useState } from 'react';

type ConfirmActionProps = {
  label: string;
  confirmLabel?: string;
  cancelLabel?: string;
  pendingLabel?: string;
  onConfirm: () => void;
  disabled?: boolean;
  pending?: boolean;
  /** Visual weight of the trigger; destructive actions take 'danger'. */
  variant?: 'primary' | 'secondary' | 'danger';
};

/**
 * A two-step action: the first click asks "are you sure" instead of firing
 * immediately, which is what "Marcar completada" and other one-way actions
 * need. `onConfirm` only ever runs from the explicit confirm click.
 */
const VARIANT_CLASS = {
  primary: 'btn small',
  secondary: 'btn small secondary',
  danger: 'btn small danger',
} as const;

export function ConfirmAction({
  label,
  confirmLabel = 'Sí, confirmar',
  cancelLabel = 'Cancelar',
  pendingLabel = 'Guardando…',
  onConfirm,
  disabled = false,
  pending = false,
  variant = 'primary',
}: ConfirmActionProps) {
  const [confirming, setConfirming] = useState(false);

  if (pending) {
    return (
      <button type="button" className="btn small secondary" disabled>
        {pendingLabel}
      </button>
    );
  }

  if (!confirming) {
    return (
      <button
        type="button"
        className={VARIANT_CLASS[variant]}
        disabled={disabled}
        onClick={() => setConfirming(true)}
      >
        {label}
      </button>
    );
  }

  return (
    <span className="action-pair">
      <button
        type="button"
        className={variant === 'danger' ? VARIANT_CLASS.danger : 'btn small'}
        onClick={() => {
          setConfirming(false);
          onConfirm();
        }}
      >
        {confirmLabel}
      </button>
      <button type="button" className="btn small ghost" onClick={() => setConfirming(false)}>
        {cancelLabel}
      </button>
    </span>
  );
}
